import React from 'react';
import { Card, CardTitle, DialogContainer, Button } from 'react-md';
import LazyLoad from 'react-lazy-load';

const styles = {
  card: { margin: 10, cursor: 'pointer' },
  cardImage: { maxWidth: '100%', height: 300 },
  dialogImage: { maxWidth: '100%', marginBottom: 10 },
  title: { wordWrap: 'break-word' }
}

class RobotCard extends React.PureComponent {
  state = {
    visible: false,
  }

  show = () => {
    this.setState({ visible: true });
  };

  hide = () => {
    this.setState({ visible: false });
  };

  render() {
    return (
      <Card style={styles.card} className='md-block-centered'>
        <DialogContainer
          id="robot-details"
          aria-label="Robot Details"
          visible={this.state.visible}
          focusOnMount={false}
          onShow={this.handleShow}
          onHide={this.hide}
          width='60%'
        >
          <img src={this.props.image} alt={this.props.name} style={styles.dialogImage} className='md-block-centered' />
          <div dangerouslySetInnerHTML={{__html: this.props.postHTML}} />
          <a href={this.props.postLink} target='_blank'><Button raised className='md-block-centered'>View post on reddit</Button></a>
        </DialogContainer>
        <LazyLoad>
          <img src={this.props.image} alt={this.props.name} style={styles.cardImage} onClick={this.show} />
        </LazyLoad>
        <CardTitle
          title={`${this.props.name} (Group ${this.props.group})`}
          subtitle={this.props.builder}
          onClick={this.show}
          style={styles.title}
        />
      </Card>
    );
  }
};

export default RobotCard;


// WEBPACK FOOTER //
// ./src/components/robotcard.js